import { render, staticRenderFns } from "./assign-states-table.vue?vue&type=template&id=c5def572&scoped=true&"
import script from "./assign-states-table.vue?vue&type=script&lang=js&"
export * from "./assign-states-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5def572",
  null
  
)

export default component.exports